import React from "react";

import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";

import Expenses from "./Expenses";
import Treasury from "./Treasury";
import DailySafeSummary from "./DailySafeSummary";

import "./CashAndDisbursements.css";

const CashAndDisbursements = () => {
  return (
    <div
      className="cash-disbursements-page"
      dir="rtl"
    >
      <Sidebar />

      <div className="cash-disbursements-body">

        <div className="cash-disbursements-header">
          <Header />
        </div>

        <main className="cash-disbursements-main">
          <div className="cash-disbursements-content">

            {/* =========================
                Page Title
            ========================== */}

            <div className="cash-page-title">
              <h1>
                حركة النقدية والمنصرف
              </h1>

              <p>
                إدارة حركة المنصرف والخزنة
              </p>
            </div>

            {/* =========================
                Daily Safe Summary
            ========================== */}

            <DailySafeSummary />

            {/* =========================
                Cards
            ========================== */}

            <div className="cash-cards-grid">


              <Treasury />

              <Expenses />
            </div>

          </div>
        </main>

      </div>
    </div>
  );
};

export default CashAndDisbursements;